import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  cta: {
    color: "#ffffff",
    backgroundColor: "#DE148C",
    fontWeight: 600,
    borderRadius: "10px",
    textTransform: "none",
    fontSize: "15px",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#C40F7A",
      boxShadow: "0 4px 12px rgba(222, 20, 140, 0.25)",
      transform: "translateY(-1px)",
    },
  },
  navbarCta: {
    color: "#ffffff",
    backgroundColor: "#DE148C",
    fontWeight: 600,
    borderRadius: "8px",
    textTransform: "none",
    padding: "8px 18px",
    fontSize: "14px",
    boxShadow: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#C40F7A",
      boxShadow: "0 2px 8px rgba(222, 20, 140, 0.2)",
    },
  },
}));

export default function RegisterCTA(props) {
  const classes = useStyles();
  const isNav = Boolean(props.navBar);

  return (
    <Button
      style={{
        width: props.width,
        height: props.height,
        padding: props.padding ?? (isNav ? "8px 18px" : "12px 24px"),
      }}
      className={isNav ? classes.navbarCta : classes.cta}
      variant="contained"
      href={
        props.href ??
        "https://partner.ur-hub.com/landing?utm_source=company+profile&utm_medium=cta&utm_id=registration"
      }
      target="_blank"
      rel="noreferrer"
    >
      <span
        style={{
          fontWeight: 600,
          fontSize: props.fontSize ? Number(props.fontSize) : (isNav ? 14 : 15),
          color: props.fontColor ?? "#ffffff",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        {props.text ?? "Coba Gratis"}
      </span>
    </Button>
  );
}
